import { render, staticRenderFns } from "./sidebar-add.vue?vue&type=template&id=777c9ea6&"
import script from "./sidebar-add.vue?vue&type=script&lang=js&"
export * from "./sidebar-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports